export const textData = {
  our: "Наша",
  mission: "Миссия",
  missionText:
    "The importance of the client-orientation approach is more than just a value – it’s our business philosophy. We believe that 80% of success is listening to the client’s needs and defining the right goal to achieve the desired result. We measure our success by the success of our clients.",
  trand: "trandwatching",
  work: "work",
  reliable: "reliable"
};
